<template>
  <div class="container">
    <div class="header">
      <div class="header__inner">
        <div class="btn btn-preview" :class="{disabled: loading}" @click="onClickSubmit"><i></i><span>图像预览</span></div>

        <div class="btn btn-prev"
          @click="prevPic(btnPrevDisabled)"
        ><i class="icon-editor-undo" :class="{disabled: btnPrevDisabled}"></i></div>
        <div class="btn btn-next"
          @click="nextPic(btnNextDisabled)"
        ><i class="icon-editor-redo" :class="{disabled: btnNextDisabled}"></i></div>
        <div class="btn btn-add" :class="{disabled: !pic || loading}" @click="addPicToEditor">导出添加</div>
        <div class="btn btn-close" @click="close()">退出</div>
      </div>
    </div>
    <div
      class="content"
      v-loading="loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      element-loading-text="正在生成文字云"
    >
      <img v-show="!isBlank" ref="picRef" class="content__img" :src="$handleAssetsUrl(pic)" alt="">
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      pic: '',
      loading: false,
      picHistory: [],
      picPointer: -1,
      cacheParams: {},
      isBlank: false,
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
    ]),
    btnPrevDisabled () {
      return this.picHistory.length < 2 || this.picPointer <= 0;
    },
    btnNextDisabled () {
      return this.picHistory.length < 2 || this.picPointer >= this.picHistory.length - 1;
    }
  },
  methods: {
    onClickSubmit () {
      this.$bus.emit('wordCloud.submit');
    },
    async submit (content, shape, style) {
      style = {
        wordCount: 400,
        wordMargin: 10,
        transparence: 20,
        defaultFontColor: false,
        font: '',
        ...style,
      }

      let params = {
        content: content || [],
        mask: shape.url,
        maskId: shape.id,
        repeat: 1,
        margin: style.wordMargin,
        countOfWord: style.wordCount,
        // blend: ((100 - style.transparence) / 100).toFixed(2) - 0,
        maskAlpha: ((100 - style.transparence) / 100).toFixed(2) - 0,
        defaultFontColor: style.defaultFontColor,
        font: style.font,
        backgroundColor: style.colorHex || '#ffffff',
        isAlpha: style.isAlpha ? 1 : 0,

        // isBlend: style.isBlend ? 1 : 0,
        // width: 1000,
        // height: 1000,
      }
      if (style.bgTransparent) {
        delete params.backgroundColor;
      }

      this.isBlank = false;

      if (this.cacheParams === JSON.stringify(params)) {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
        }, 500);
        return;
      }

      if (this.loading) {
        return;
      }
      this.loading = true;
      this.cacheParams = JSON.stringify(params);
      return this.$http({
        url: '/api/wordcloud',
        method: 'post',
        data: params,
        // headers: {'Content-Type': 'application/x-www-form-urlencoded'}
      })
        .then(res => {
          this.pic = res.data.data.filename;
          this.picHistory.push(this.pic);
          this.picPointer = this.picHistory.length - 1;

          $(this.$refs.picRef).one('load', (el) => {
            this.loading = false;
          })

          this.$analysis('word_cloud,click_image_render，文字云_点击_图像渲染')

        })
        .catch(err => {
          this.loading = false;
        })
    },
    prevPic (disabled) {
      this.movePicPointer(-1, disabled);
    },
    nextPic (disabled) {
      this.movePicPointer(1, disabled);
    },
    movePicPointer (flag, disabled) {
      if (disabled || this.loading) {
        return;
      }
      this.picPointer += flag;
      this.pic = this.picHistory[this.picPointer];
      this.isBlank = false;
    },

    close () {
      if (this.loading) {
        return;
      }
      this.$modal.show('wordCloud.confirm', {
        name: 'closeWordCloudDialog',
        text: '您确定要退出文字云吗?'
      });
      this.$bus.once('wordCloud.confirm.do', (thing) => {
        if (thing.name === 'closeWordCloudDialog') {
          this.doClose();
          this.$analysis('word_cloud,click_exit，文字云_点击_退出');
        }
      });
      this.$bus.emit('FeaturesPop_close_vue', {
        type: 3,
      });

      this.$analysis('word_cloud,click_exit_confirm，文字云_点击_退出_确定');
    },

    doClose () {
      this.$store.commit('save_TopnavMsg', {
        isShowWordCloudDialog: false
      });

      this.$bus.emit('wordCloud.addPicToEditorDone');
    },

    addPicToEditor () {
      if (!this.pic || this.loading) {
        return;
      }
      this.$http.post('/api/user/pic', {
        title: '',
        url: this.pic,
        thumbnailUrl: this.pic,
        share: 0
      })
        .then(res => {
          this.$bus.emit('collectPersonal_vue',{data: 'collectPic'});

          this.TOOL.addSprite('Image', {
            trackingType: '1001',
            url: this.pic,
            fileType : 18
          }, null, true);

          this.doClose();
          // this.isBlank = true;

          this.$analysis('word_cloud,click_export_insert，文字云_点击_导出添加')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 648px - 3px;
	height: 56px;
	background-color: #e8e8ef;
	border-radius: 4px;

  &__inner {
    position: relative;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 628px;
    height: 34px;
  }
}

.btn-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 120px;
	height: 34px;
	line-height: 34px;
	background-color: #e8195e;
	box-shadow: 0px 0px 4px 0px
		rgba(44, 75, 248, 0.2);
	border-radius: 4px;
  color: #fff;

  & > span {
    color: #fff;
  }

  & > i {
    width: 14px;
    height: 14px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url(../../../../static/svg/word-cloud/eye.svg);
    margin-right: 11px;
    margin-top: 2px;
  }

  &:hover {
    background-color: #f1588a;
  }
}
.btn-add {
  width: 100px;
	height: 34px;
	line-height: 34px;
	background-color: #5778fb;
	box-shadow: 0px 0px 4px 0px
		rgba(44, 75, 248, 0.2);
	border-radius: 4px;
  color: #fff;
  margin-left: 10px;
}
.btn-close {
  width: 80px;
	height: 34px;
	line-height: 34px;
	background-color: #ffffff;
	box-shadow: 0px 0px 4px 0px
		rgba(44, 75, 248, 0.2);
	border-radius: 4px;
  margin-left: 10px;
}

.content {
  position: relative;
  width: 648px - 3px;
	height: 598px;
	background-color: #ffffff;
	border-radius: 4px;
	border: solid 1px #d9ddea;
  margin-top: 3px;
  margin-right: 3px;
  background-image: url("data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjE2IiB3aWR0aD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iI0YwRjBGMCIgZD0iTTAgMGg4djhIMHptOCA4aDh2OEg4eiIvPjwvc3ZnPg==");

  &__img {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 0;
    margin: auto;
    width: auto;
    height: auto;
    max-width: 90%;
    max-height: 90%;
  }
}

.btn-prev, .btn-next {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
	height: 34px;
	background-color: #ffffff;
	box-shadow: 0px 0px 4px 0px
		rgba(44, 75, 248, 0.2);
	border-radius: 4px;
}

.btn-next {
  margin-left: 10px;
}

.btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/wordCloud/viewer.vue